import { API_ERR_MESSAGE } from '../config/constant'

// readable message from a failed API call
// uses the first backend validation error when there is one, else the backend message, else the fallback
//==============================
export const apiErrorMessage = (err, fallback = API_ERR_MESSAGE) => {
    const data = err?.response?.data

    const errors = data?.errors
    if (errors && typeof errors === 'object') {
        const first = Object.values(errors).flat()[0]
        if (first) return first
    }

    if (data?.message && data.message !== 'Validation errors') return data.message

    return fallback
}
